/* global debounce */
if (!customElements.get('cart-note')) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest('details');

      if (this.disclosure && this.disclosure.matches('.cart-note-disclosure')) {
        this.cartNoteToggle = this.disclosure.querySelector('.js-show-note');
      }

      this.init();
    }

    init() {
      this.debouncedHandleNoteChange = debounce(this.handleNoteChange.bind(this), 300);
      // Save as soon as possible, avoid link-click not providing time to save
      this.addEventListener('input', this.debouncedHandleNoteChange);
    }

    handleNoteChange(evt) {
      if (this.cartNoteToggle) {
        const label = evt.target.value ? theme.strings.editCartNote : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label) this.cartNoteToggle.textContent = label;
      }

      const note = evt.target.value;
      if (!window.SVCart) {
        const errorTarget = this.isConnected === false ? document : this;
        errorTarget.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: { error: theme.strings.svGenericError || theme.strings.cartError }
        }));
        return;
      }
      window.SVCart.enqueue(
        'cart-note:update',
        (cartContext) => cartContext.post(theme.routes.cartUpdate, { note }),
        { publish: () => undefined }
      ).catch((error) => {
        if (error?.svCartErrorDispatched !== true) {
          const errorTarget = this.isConnected === false ? document : this;
          errorTarget.dispatchEvent(new CustomEvent('on:cart:error', {
            bubbles: true,
            detail: { error: error.message }
          }));
        }
      });
    }
  }

  customElements.define('cart-note', CartNote);
}
